import React from 'react';
import { DollarSign, Heart, CreditCard, FileText } from 'lucide-react';

const DonorStatsCards = ({ stats, text, formatAmount }) => {
  const cards = [
    {
      id: 'total-donated',
      icon: DollarSign,
      iconBg: 'bg-[#D4AF37]/10',
      iconColor: 'text-[#D4AF37]',
      value: formatAmount(stats?.total_donated),
      label: text.totalDonated,
    },
    {
      id: 'total-donations',
      icon: Heart,
      iconBg: 'bg-[#4A708B]/10',
      iconColor: 'text-[#4A708B]',
      value: stats?.total_donations || 0,
      label: text.totalDonations,
    },
    {
      id: 'active-subscriptions',
      icon: CreditCard,
      iconBg: 'bg-green-100',
      iconColor: 'text-green-600',
      value: stats?.active_subscriptions || 0,
      label: text.activeSubscriptions,
    },
    {
      id: 'receipts-available',
      icon: FileText,
      iconBg: 'bg-purple-100',
      iconColor: 'text-purple-600',
      value: stats?.receipts_available || 0,
      label: text.receiptsAvailable,
    },
  ];

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.id}
          data-testid={`stat-card-${card.id}`}
          className="bg-white rounded-2xl p-6 shadow-sm"
        >
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-10 h-10 rounded-xl ${card.iconBg} flex items-center justify-center`}>
              <card.icon className={`w-5 h-5 ${card.iconColor}`} />
            </div>
          </div>
          <p className="text-2xl font-bold text-[#1A252C]">{card.value}</p>
          <p className="text-sm text-[#546A76]">{card.label}</p>
        </div>
      ))}
    </div>
  );
};

export default DonorStatsCards;
